import React, { FC, useState } from 'react';

import { FilterVariant } from '../../types/company.types';
import MyCompaniesHeader from './components/header';
import MyCompaniesItemsList from './my-companies-items-list';

export const MyCompanies: FC = () => {
  const [selectedFilter, setSelectedFiler] = useState<FilterVariant>('all');

  return (
    <div className="flex h-fit min-h-full w-full flex-col rounded-md border-gray-100 max-lg:gap-4 lg:border-[1px] lg:shadow-sm">
      <MyCompaniesHeader selectedFilter={selectedFilter} setSelectedFilter={setSelectedFiler} />
      <div className="h-[1px] w-full bg-gray-100" />
      <div className="flex min-h-[96px] flex-1 flex-col">
        <MyCompaniesItemsList selectedFilter={selectedFilter} />
      </div>
    </div>
  );
};
